module.exports = __webpack_public_path__ + "media/images/webinar/adler-a857fd4e81a7c8cfd243c7be6c08a7f1.jpg";